import { render, staticRenderFns } from "./StatisticCard.vue?vue&type=template&id=0ae59558&scoped=true&"
import script from "./StatisticCard.vue?vue&type=script&lang=ts&"
export * from "./StatisticCard.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticCard.vue?vue&type=style&index=0&id=0ae59558&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae59558",
  null
  
)

export default component.exports